// extracted by mini-css-extract-plugin
export default {"container":"privacy_container__A5dkA","title":"privacy_title__EoJqi","updated":"privacy_updated__nYiOi","section":"privacy_section__4LZ8e"};